import { PlaylistEventType } from './playlist-event-type';

const playlist = {
  PlaylistEventType
};

export { playlist };
